import PropTypes from "prop-types";
import MetaTags from "react-meta-tags";
import React, {useState} from "react";

import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label } from "reactstrap";

import { withRouter, Link, useHistory } from "react-router-dom";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import axios from "axios";

// import images
import profile from "assets/images/logo-light.png";
import bg from "assets/images/background_image.jpg";

import toastr from "toastr";
import { TOAST_OPTIONS, Config } from "helpers/backend_helper";
import { COMPANY, POST_LOGIN } from "helpers/url_helper";

const Login = props => {
  const history = useHistory()
  const [isLoading, setIsLoading] = useState(false)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  toastr.options = TOAST_OPTIONS;

  const validation  = () =>{
      const data = {
        email: email,
        password: password
      };
     
      setIsLoading(true)
      axios.post(POST_LOGIN, JSON.stringify(data), Config)
      .then(function(response){
          if(response.data.status == 1){
            localStorage.setItem("authWTUser", JSON.stringify(response.data.user))
            if(response.data.user.changePass == 1){
              toastr.success('Please change password'); 
              history.push("/change-password")
            }else{
              toastr.success(response.data.message); 
              history.push("/dashboard")
            } 
          }else{
              toastr.error(response.data.message)
          }
          setIsLoading(false)
      })
      .catch(function (error) {
          toastr.error(error);
          console.log(error)
          setIsLoading(false)
      })
    }
    const handleKeyPress = (e) => {
      if (e.key === 'Enter') {
        validation();
      }
    };

  return (
    <React.Fragment>
      <MetaTags>
        <title>{COMPANY}</title>
      </MetaTags>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className=" bg-soft">
                  <Row>
                    <Col xs={12}>
                      <div className="text-primary p-4">
                      <img src={profile} alt="" className="img-fluid" height="40" />
                      </div>
                    </Col>
                  
                  </Row>
                </div>
                <CardBody className="pt-0">
                 
                  <div className="p-2">
                      <div className="mb-3">
                        <Label className="form-label">E-mail</Label>
                        <Input
                          className="form-control"
                          type="text"
                          value={email}
                          onChange={(e)=>setEmail(e.target.value)}
                          onKeyPress={handleKeyPress}
                        />
                     
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">Password</Label>
                        <Input
                          type="password"
                          value={password}
                          onChange={(e)=>setPassword(e.target.value)}
                          onKeyPress={handleKeyPress}
                        />
                      </div>

                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="customControlInline"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="customControlInline"
                        >
                          Remember me
                        </label>
                      </div>

                      <div className="mt-3 d-grid">
                      {isLoading?(
                          <button
                            className="btn btn-warning w-md "
                            type="button"
                          >
                            Please wait...
                          </button>
                        ):(
                        <button
                          className="btn btn-primary btn-block"
                          type="button"
                          onClick={validation}
                        >
                          Log In
                        </button>
                        )}
                      </div>

                      <div className="mt-4 text-center">
                        <Link to="/forgot-password" className="text-muted">
                          <i className="mdi mdi-lock me-1" />
                          Forgot your password?
                        </Link>
                      </div>
                   
                  </div>
                  <div className="mt-5 text-center">
  
              </div>
                </CardBody>
              </Card>
              
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};
